module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryoutgroup-form"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Video Pembelajaran',
          to: {
            path: '/video'
          },
          exact: true,
        },
        {
          text: 'Tambah Video Baru'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("\n        " + _vm._s(!_vm.$route.query.id ?
    "Tambah Video Baru" :
    "Ubah Video Pembelajaran") + "\n    ")]), _vm._v(" "), _c('v-card', {
    staticClass: "pa-7",
    attrs: {
      "plain": ""
    }
  }, [_c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    URL Video *\n                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Masukkan URL Video dan tekan enter",
      "outlined": ""
    },
    on: {
      "keypress": function($event) {
        return _vm.hideForm()
      }
    },
    model: {
      value: (_vm.url),
      callback: function($$v) {
        _vm.url = $$v
      },
      expression: "url"
    }
  }), _vm._v(" "), (_vm.changeUrl) ? _c('v-btn', {
    staticClass: "font-weight-bold dark--text",
    staticStyle: {
      "box-shadow": "0px 4px 4px rgba(0, 0, 0, 0.05)",
      "border-radius": "4px"
    },
    attrs: {
      "block": "",
      "depressed": "",
      "color": "#FAFAFA"
    },
    on: {
      "click": function($event) {
        return _vm.checkURL()
      }
    }
  }, [_vm._v("Preview Video")]) : _vm._e(), _vm._v(" "), (!_vm.changeUrl) ? _c('div', {
    staticStyle: {
      "width": "50% !important",
      "padding": "0px 0px 20px 0px"
    }
  }, [(_vm.url && _vm.$youtube.getIdFromUrl(_vm.url)) ? _c('youtube', {
    key: _vm.videoKey,
    ref: "youtube",
    attrs: {
      "video-id": _vm.$youtube.getIdFromUrl(_vm.url)
    },
    on: {
      "playing": _vm.playing
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), (!_vm.changeUrl) ? _c('div', [_c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pa-0"
  }, [_vm._v("\n                        Source\n                    ")]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.source),
      callback: function($$v) {
        _vm.source = $$v
      },
      expression: "source"
    }
  }, [_c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "label": "Youtube",
      "value": "youtube",
      "active-class": "act-radio-btn"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                        Judul Video *\n                    ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Judul Video",
      "outlined": "",
      "hide-details": !_vm.$route.query.id && !_vm.$route.query.liveId ? 'auto' : false
    },
    model: {
      value: (_vm.judul),
      callback: function($$v) {
        _vm.judul = $$v
      },
      expression: "judul"
    }
  }), _vm._v(" "), (!_vm.$route.query.id && !_vm.$route.query.liveId) ? _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "Judul Alternatif",
      "value": true,
      "hide-details": "",
      "outlined": ""
    },
    model: {
      value: (_vm.altTitle),
      callback: function($$v) {
        _vm.altTitle = $$v
      },
      expression: "altTitle"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.altTitle) ? _c('v-text-field', {
    attrs: {
      "placeholder": "Judul Alternatif",
      "outlined": "",
      "required": _vm.altTitle
    },
    model: {
      value: (_vm.judulalt),
      callback: function($$v) {
        _vm.judulalt = $$v
      },
      expression: "judulalt"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                        Durasi *\n                    ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "number",
      "placeholder": "Durasi (dalam detik)",
      "outlined": ""
    },
    model: {
      value: (_vm.duration),
      callback: function($$v) {
        _vm.duration = $$v
      },
      expression: "duration"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                        Deskripsi\n                    ")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "placeholder": "Deskripsi",
      "outlined": ""
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                        Jenjang *\n                    ")]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    on: {
      "change": function($event) {
        return _vm.resetKelas()
      }
    },
    model: {
      value: (_vm.jenjang),
      callback: function($$v) {
        _vm.jenjang = $$v
      },
      expression: "jenjang"
    }
  }, _vm._l((_vm.jenjangList), function(item) {
    return _c('v-radio', {
      key: item,
      staticClass: "jenjang-selection",
      attrs: {
        "label": item,
        "value": item,
        "active-class": "act-radio-btn"
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), (_vm.jenjang !== null) ? _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                        Kelas *\n                    ")]), _vm._v(" "), (_vm.jenjang === 'SD') ? _c('div', {
    staticClass: "d-inline"
  }, [_c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "1",
      "value": 1,
      "outlined": ""
    },
    model: {
      value: (_vm.kelas),
      callback: function($$v) {
        _vm.kelas = $$v
      },
      expression: "kelas"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "2",
      "value": 2,
      "outlined": ""
    },
    model: {
      value: (_vm.kelas),
      callback: function($$v) {
        _vm.kelas = $$v
      },
      expression: "kelas"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "3",
      "value": 3,
      "outlined": ""
    },
    model: {
      value: (_vm.kelas),
      callback: function($$v) {
        _vm.kelas = $$v
      },
      expression: "kelas"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "4",
      "value": 4,
      "outlined": ""
    },
    model: {
      value: (_vm.kelas),
      callback: function($$v) {
        _vm.kelas = $$v
      },
      expression: "kelas"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "5",
      "value": 5,
      "outlined": ""
    },
    model: {
      value: (_vm.kelas),
      callback: function($$v) {
        _vm.kelas = $$v
      },
      expression: "kelas"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "6",
      "value": 6,
      "outlined": ""
    },
    model: {
      value: (_vm.kelas),
      callback: function($$v) {
        _vm.kelas = $$v
      },
      expression: "kelas"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.jenjang === 'SMP') ? _c('div', {
    staticClass: "d-inline"
  }, [_c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "7",
      "value": 7,
      "outlined": ""
    },
    model: {
      value: (_vm.kelas),
      callback: function($$v) {
        _vm.kelas = $$v
      },
      expression: "kelas"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "8",
      "value": 8,
      "outlined": ""
    },
    model: {
      value: (_vm.kelas),
      callback: function($$v) {
        _vm.kelas = $$v
      },
      expression: "kelas"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "9",
      "value": 9,
      "outlined": ""
    },
    model: {
      value: (_vm.kelas),
      callback: function($$v) {
        _vm.kelas = $$v
      },
      expression: "kelas"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.jenjang === 'SMA') ? _c('div', {
    staticClass: "d-inline"
  }, [_c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "10",
      "value": 10,
      "outlined": ""
    },
    model: {
      value: (_vm.kelas),
      callback: function($$v) {
        _vm.kelas = $$v
      },
      expression: "kelas"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "11",
      "value": 11,
      "outlined": ""
    },
    model: {
      value: (_vm.kelas),
      callback: function($$v) {
        _vm.kelas = $$v
      },
      expression: "kelas"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "12",
      "value": 12,
      "outlined": ""
    },
    model: {
      value: (_vm.kelas),
      callback: function($$v) {
        _vm.kelas = $$v
      },
      expression: "kelas"
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.jenjang === 'SMA') ? _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                        Peminatan\n                    ")]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.interest),
      callback: function($$v) {
        _vm.interest = $$v
      },
      expression: "interest"
    }
  }, [_c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "label": "Semua",
      "value": "ALL",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "label": "IPA",
      "value": "SAINTEK",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "label": "IPS",
      "value": "SOSHUM",
      "active-class": "act-radio-btn"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                        Status User ")]), _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "id": "live_class_type_free",
      "label": "FREE",
      "value": "FREE",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "id": "live_class_type_premium",
      "label": "PREMIUM",
      "value": "PREMIUM",
      "active-class": "act-radio-btn"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                        Kurikulum ")]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.kurikulum),
      callback: function($$v) {
        _vm.kurikulum = $$v
      },
      expression: "kurikulum"
    }
  }, [_c('v-radio', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "KM",
      "value": "KM",
      "outlined": ""
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "K13",
      "value": "K13",
      "outlined": ""
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "K13 IPA",
      "value": "saintek",
      "outlined": ""
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "K13 IPS",
      "value": "soshum",
      "outlined": ""
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "TKA",
      "value": "TKA",
      "outlined": ""
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                        Mata Pelajaran *\n                    ")]), _vm._v(" "), _c('v-select', {
    staticClass: "pa-0",
    attrs: {
      "items": _vm.mapelList,
      "outlined": "",
      "item-text": "nama",
      "item-value": "id",
      "placeholder": "Ketik mata pelajaran",
      "chips": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-list-item', {
          staticClass: "pa-0 ma-0"
        }, [_c('v-list-item-avatar', {
          staticClass: "ma-0"
        }, [_c('img', {
          attrs: {
            "src": item.picture
          }
        })]), _vm._v(" "), _c('v-list-item-title', [_vm._v(_vm._s(item.nama))])], 1)]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-list-item-avatar', [_c('img', {
          attrs: {
            "src": item.picture
          }
        })]), _vm._v(" "), _c('v-list-item-title', [_vm._v(_vm._s(item.nama))])]
      }
    }], null, false, 82209147),
    model: {
      value: (_vm.mapel),
      callback: function($$v) {
        _vm.mapel = $$v
      },
      expression: "mapel"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                        Topik *\n                    ")]), _vm._v(" "), _c('app-autocomplete', {
    attrs: {
      "placeholder": "Cari Bab / (Sub) Sub Bab",
      "data": _vm.topics,
      "value": _vm.topic,
      "topic": _vm.subSubBabId ?
        _vm.subSubBabId :
        _vm.subBabId ?
        _vm.subBabId :
        _vm.babId
    },
    on: {
      "selected": function($event) {
        return _vm.assignTopic($event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                        Status ")]), _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, [_c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "label": "Draft",
      "value": "DRAFT",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "label": "Review",
      "value": "REVIEW",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "label": "Publikasi",
      "value": "PUBLISHED",
      "active-class": "act-radio-btn"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pt-0 px-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                        User Group\n                    ")]), _vm._v(" "), _vm._l((_vm.user_group), function(usgr, i) {
    return _c('v-autocomplete', {
      key: i,
      attrs: {
        "items": _vm.user_groups,
        "item-text": "user_group_name",
        "item-value": "id",
        "placeholder": "-- Pilih user group --",
        "outlined": ""
      },
      scopedSlots: _vm._u([{
        key: "append-outer",
        fn: function() {
          return [(
            i === _vm.user_group.length - 1 &&
            _vm.user_group.length != 1
          ) ? _c('v-btn', {
            staticClass: "font-weight-bold dark--text",
            attrs: {
              "id": "user-remove-scope-btn",
              "dark": "",
              "large": "",
              "depressed": "",
              "color": "white"
            },
            on: {
              "click": function($event) {
                _vm.queryId ? null : _vm.user_group.splice(i, 1)
              }
            }
          }, [_vm._v("\n                                Hapus\n                            ")]) : _vm._e()]
        },
        proxy: true
      }], null, true),
      model: {
        value: (_vm.user_group[i]),
        callback: function($$v) {
          _vm.$set(_vm.user_group, i, $$v)
        },
        expression: "user_group[i]"
      }
    })
  })], 2)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-btn', {
    staticClass: "font-weight-bold blew--text mb-5 mt-8",
    attrs: {
      "id": "user-add-scope-btn",
      "block": "",
      "depressed": "",
      "color": "#e8f5fa"
    },
    on: {
      "click": function($event) {
        return _vm.user_group.push('')
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    staticStyle: {
      "font-size": "16px !important"
    }
  }, [_vm._v("\n                    mdi-plus-circle\n                ")]), _vm._v("\n                Tambah User Group Baru\n            ")], 1), _vm._v(" "), (_vm.$route.query.id) ? _c('v-btn', {
    staticClass: "font-weight-bold blew--text mb-5",
    attrs: {
      "block": "",
      "depressed": "",
      "color": "#e8f5fa"
    },
    on: {
      "click": function($event) {
        _vm.pushNew(), _vm.fetchData()
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    staticStyle: {
      "font-size": "22px !important"
    }
  }, [_vm._v("\n                    mdi-sort-bool-ascending-variant\n                ")]), _vm._v("\n                Atur Urutan Video\n            ")], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.changeUrl) ? _c('v-divider') : _vm._e(), _vm._v(" "), (!_vm.changeUrl) ? _c('v-card-actions', {
    staticClass: "py-2"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-3",
    attrs: {
      "color": "primary",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        !_vm.$route.query.id && !_vm.$route.query.liveId ?
          _vm.saveData() :
          _vm.editData()
      }
    }
  }, [_vm._v("\n                Simpan\n            ")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e(), _vm._v(" "), (_vm.showModal) ? _c('app-modal', {
    attrs: {
      "withCancel": true
    },
    on: {
      "ok": function($event) {
        return _vm.removeDependency()
      },
      "cancel": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('h4', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Hapus Pra-Syarat")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._v("\n            Apakah anda yakin akan menghapus pra-syarat\n            "), _c('strong', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.dependencyName))]), _vm._v(" ?\n        ")])]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "transition": "dialog-top-transition",
      "width": "940px",
      "min-height": "537px",
      "max-height": "771px",
      "scrollable": ""
    },
    on: {
      "click:outside": function($event) {
        _vm.modalUrutan = false
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(dialog) {
        return [_c('v-card', [_c('v-card-title', [_vm._v("\n                    Urutan Video\n                    "), (_vm.bab_name) ? _c('span', {
          staticClass: "ml-2"
        }, [_vm._v("\n                        (Bab " + _vm._s(_vm.bab_name) + "\n                        "), _c('a', {
          staticClass: "blew--text"
        }, [_vm._v("Kelas " + _vm._s(_vm.selected_sort_class))]), _vm._v(")\n                    ")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.loading_sequence) ? _c('v-progress-circular', {
          attrs: {
            "indeterminate": "",
            "color": "primary",
            "size": 30
          }
        }) : _vm._e(), _vm._v(" "), (_vm.updated_sequence && !_vm.loading_sequence) ? _c('v-icon', {
          staticStyle: {
            "font-size": "32px"
          },
          attrs: {
            "color": "blew"
          }
        }, [_vm._v("mdi-check-circle")]) : _vm._e()], 1), _vm._v(" "), _c('v-card-subtitle', [_c('div', [_vm._v("Atur urutan dengan drag list video")]), _vm._v(" "), _c('div', {
          staticClass: "mt-5 mb-5"
        }, _vm._l((_vm.kelas), function(data_kelas, index) {
          return _c('v-btn', {
            key: index,
            staticClass: "mr-2",
            class: _vm.selected_sort_class === data_kelas ?
              'blew--text' :
              'grey--text',
            attrs: {
              "color": _vm.selected_sort_class === data_kelas ?
                '#e8f5fa' :
                '#f3f5f7',
              "depressed": "",
              "rounded": ""
            },
            on: {
              "click": function($event) {
                (_vm.selected_sort_class = data_kelas),
                _vm.fetchData(data_kelas)
              }
            }
          }, [_vm._v("\n                            Kelas " + _vm._s(data_kelas) + "\n                        ")])
        }), 1)]), _vm._v(" "), _c('v-card-text', {
          attrs: {
            "width": "100%"
          }
        }, [_c('div', {
          staticClass: "mt-3 mb-5 pl-4 font-weight-bold"
        }, [
          [_c('v-row', [_c('v-col', {
            attrs: {
              "cols": "2"
            }
          }, [_vm._v("Nomor Urut")]), _vm._v(" "), _c('v-col', {
            attrs: {
              "cols": "8"
            }
          }, [_vm._v("Nama Video")])], 1)]
        ], 2), _vm._v(" "), (_vm.isLoading) ? _c('div', {
          staticClass: "mt-8"
        }, [_c('v-skeleton-loader', _vm._b({
          attrs: {
            "type": "card"
          }
        }, 'v-skeleton-loader', _vm.attrs, false))], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', [_c('draggable', {
          staticClass: "list-group",
          attrs: {
            "list": _vm.video2,
            "disabled": !_vm.enabled,
            "ghost-class": "ghost",
            "move": _vm.checkMove
          },
          on: {
            "start": function($event) {
              _vm.dragging = true
            },
            "end": _vm.finishDragged
          }
        }, [_vm._l((_vm.video2), function(element, index) {
          return _c('div', {
            key: element.id,
            staticClass: "list-group-item pa-6 draggable",
            class: element.id == _vm.$route.query.id ?
              'selected' :
              ''
          }, [_c('v-row', [_c('v-col', {
            attrs: {
              "cols": "2",
              "md": "2"
            }
          }, [_c('v-btn', {
            staticClass: "font-weight-bold",
            staticStyle: {
              "font-size": "14px"
            },
            attrs: {
              "color": element.id ==
                _vm.$route.query.id ?
                '#29b6f6' :
                'blew',
              "rounded": "",
              "fab": "",
              "x-small": "",
              "dark": "",
              "depressed": ""
            }
          }, [_vm._v("\n                                            " + _vm._s(index + 1) + "\n                                        ")])], 1), _vm._v(" "), _c('v-col', {
            staticClass: "pt-1",
            attrs: {
              "cols": "8",
              "md": "8"
            }
          }, [_vm._v("\n                                        " + _vm._s(element.nama_video) + "\n                                    ")])], 1)], 1)
        }), _vm._v(" "), (!_vm.video2.length) ? _c('div', {
          staticClass: "text-center"
        }, [_vm._v("\n                                Video tidak tersedia\n                            ")]) : _vm._e()], 2)], 1) : _vm._e(), _vm._v(" "), _c('v-simple-table', {
          staticClass: "pa-0",
          staticStyle: {
            "display": "none"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function() {
              return [_c('thead', [_c('tr', [_c('th', {
                staticClass: "text-left"
              }, [_vm._v("Nomor Urut")]), _vm._v(" "), _c('th', {
                staticClass: "text-left",
                attrs: {
                  "width": "80%"
                }
              }, [_vm._v("\n                                        Nama Video\n                                    ")]), _vm._v(" "), _c('th', {
                staticClass: "text-left"
              }, [_vm._v("Aksi")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.sortedVideo), function(video, index) {
                return _c('tr', {
                  key: index,
                  attrs: {
                    "color": video.id == _vm.$route.query.id ||
                      video.nama_video === _vm.judul ?
                      '#F9F9FB' :
                      ''
                  }
                }, [_c('td', [_vm._v(_vm._s(video.no_urut))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(video.nama_video))]), _vm._v(" "), _c('td', [(
                  video.no_urut > 1 &&
                  (video.id ==
                    _vm.$route.query.id ||
                    video.new)
                ) ? _c('v-btn', {
                  staticClass: "pa-0",
                  attrs: {
                    "min-width": "32px",
                    "height": "32px",
                    "elevation": "0"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.moveUp(video)
                    }
                  }
                }, [_c('v-icon', [_vm._v("mdi-menu-up")])], 1) : _vm._e(), _vm._v(" "), (
                  video.id ==
                  _vm.$route.query.id ||
                  video.new
                ) ? _c('v-btn', {
                  staticClass: "pa-0",
                  attrs: {
                    "min-width": "32px",
                    "height": "32px",
                    "elevation": "0"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.moveDown(video)
                    }
                  }
                }, [_c('v-icon', [_vm._v("mdi-menu-down")])], 1) : _vm._e()], 1)])
              }), 0)]
            },
            proxy: true
          }], null, true)
        })], 1), _vm._v(" "), _c('v-card-text', [_c('div', {
          staticClass: "text-h2"
        })]), _vm._v(" "), _c('v-card-actions', {
          staticClass: "justify-end"
        }, [_c('v-btn', {
          attrs: {
            "text": ""
          },
          on: {
            "click": function($event) {
              dialog.value = false
            }
          }
        }, [_vm._v("Close")])], 1)], 1)]
      }
    }]),
    model: {
      value: (_vm.modalUrutan),
      callback: function($$v) {
        _vm.modalUrutan = $$v
      },
      expression: "modalUrutan"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e5e0b96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/vd_pembelajaran/components/Form.vue
// module id = 2163
// module chunks = 1